import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { loadGoogleIdentity } from "../../auth/googleIdentity";

export function GoogleSignInButton({
  clientId,
  disabled,
  onCredential,
  onError,
}: {
  clientId: string;
  disabled: boolean;
  onCredential: (_credential: string) => void;
  onError: () => void;
}) {
  const { i18n } = useTranslation();
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!clientId || disabled) return undefined;
    let active = true;

    loadGoogleIdentity(i18n.resolvedLanguage)
      .then((google) => {
        if (!active || !buttonRef.current) return;
        google.accounts.id.initialize({
          client_id: clientId,
          callback: ({ credential }) => onCredential(credential),
          auto_select: false,
          cancel_on_tap_outside: true,
        });
        google.accounts.id.renderButton(buttonRef.current, {
          type: "standard",
          theme: "filled_black",
          size: "large",
          shape: "rectangular",
          text: "continue_with",
          logo_alignment: "left",
          locale: i18n.resolvedLanguage,
          width: Math.min(366, buttonRef.current.clientWidth || 366),
        });
      })
      .catch(onError);

    return () => {
      active = false;
    };
  }, [clientId, disabled, i18n.resolvedLanguage, onCredential, onError]);

  return <div ref={buttonRef} className="flex min-h-11 w-full justify-center" aria-live="polite" />;
}
